module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "ma-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-tabs', {
    staticClass: "mb-0",
    attrs: {
      "center-active": "",
      "show-arrows": "",
      "background-color": "transparent"
    },
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, [(Object.keys(_vm.rechnungen).length === 0) ? _c('v-tab', [_vm._v("Keine Rechnungen vorhanden")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.jahre), function(jahr) {
    return _c('v-tab', {
      key: jahr
    }, [_vm._v(_vm._s(jahr))])
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.status === 'Entwurf SEPA') ? _c('v-btn', {
    staticClass: "ma-2 primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showSendRechnungen = true
      }
    }
  }, [_c('v-icon', [_vm._v("send")]), _vm._v("\n          Alle versenden und SEPA generieren\n        ")], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-tabs-items', {
    staticClass: "transparent",
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, _vm._l((_vm.rechnungen), function(jahr, index) {
    return _c('v-tab-item', {
      key: index
    }, [_c('v-data-table', {
      ref: "rechnungenTabelle",
      refInFor: true,
      attrs: {
        "dense": "",
        "height": _vm.sideHeight,
        "headers": _vm.headers,
        "items": jahr.rechnungen,
        "search": _vm.search,
        "fixed-header": "",
        "items-per-page": 100,
        "page": _vm.page,
        "hide-default-header": _vm.$vuetify.breakpoint.xsOnly,
        "no-data-text": "Keine Rechnungen vorhanden",
        "show-select": _vm.isSelect,
        "hide-default-footer": ""
      },
      on: {
        "update:page": function($event) {
          _vm.page = $event
        },
        "page-count": function($event) {
          _vm.pageCount = $event
        }
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function(ref) {
          var item = ref.item;

          return [_c('tr', {
            staticClass: "hidden-sm-and-up"
          }, [_c('th'), _vm._v(" "), _c('th', [_vm._v("Nummer")]), _vm._v(" "), _c('th', [_vm._v("Bundesbruder")]), _vm._v(" "), _c('th', [_vm._v("Betrag")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]
        }
      }, {
        key: "item",
        fn: function(ref) {
          var item = ref.item;

          return [_c('tr', {
            on: {
              "dblclick": function($event) {
                (_vm.selectRechnung = item) && (_vm.showRechnung = true)
              }
            }
          }, [(_vm.isSelect && _vm.checkIndex(item.id)) ? _c('td', {
            staticClass: "pr-0",
            attrs: {
              "width": "20px"
            }
          }, [_c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.addSelect(item.id)
              }
            }
          }, [_c('v-icon', [_vm._v("check_box_outline_blank")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isSelect && !_vm.checkIndex(item.id)) ? _c('td', {
            staticClass: "pr-0",
            attrs: {
              "width": "20px"
            }
          }, [_c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.addSelect(item.id)
              }
            }
          }, [_c('v-icon', [_vm._v("check_box")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.status === 'Mahnung' || item.status === 'Gemahnt überfällig') ? _c('td', {
            attrs: {
              "width": "100px"
            }
          }, [_c('v-chip', {
            attrs: {
              "label": "",
              "small": "",
              "outlined": "",
              "color": "red"
            }
          }, [_vm._v(_vm._s(item.mahnstufe) + ". " + _vm._s(item.status))])], 1) : _c('td', {
            attrs: {
              "width": "100px"
            }
          }, [_c('v-chip', {
            attrs: {
              "label": "",
              "small": "",
              "outlined": ""
            }
          }, [_vm._v(_vm._s(item.status))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rechnungsnummer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rechnung_titel))]), _vm._v(" "), _c('td', {
            attrs: {
              "width": "220px"
            }
          }, [_vm._v("\n                    " + _vm._s(item.kontakt) + "\n                  ")]), _vm._v(" "), _c('td', {
            staticClass: "text-right",
            attrs: {
              "width": "120px"
            }
          }, [_vm._v("\n                    " + _vm._s(_vm.$filters.money(item.summe)) + "\n                  ")]), _vm._v(" "), _c('td', {
            staticClass: "hidden-xs-only",
            attrs: {
              "width": "170px"
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('span', _vm._g({}, on), [_vm._v(_vm._s(_vm.$filters.date(item.rechnung_datum, "DD.MM.YYYY")))])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("\n                        Gestellt am:\n                        " + _vm._s(_vm.$filters.date(item.rechnung_datum, "DD.MM.YYYY")) + "\n                        "), _c('br'), _vm._v("\n                        Zahlbar bis:\n                        " + _vm._s(_vm.$filters.date(item.rechnung_zahlbar_bis, "DD.MM.YYYY")) + "\n                      ")])])], 1), _vm._v(" "), _c('td', [_c('v-menu', {
            attrs: {
              "offset-y": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  attrs: {
                    "size": "small",
                    "icon": "",
                    "variant": "flat"
                  }
                }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', {
            attrs: {
              "nav": "",
              "dense": ""
            }
          }, [(item.status === 'Entwurf') ? _c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.neuerStatus(item, 'Offen')
              }
            }
          }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("send")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Rechnungen versenden")])], 1) : _vm._e(), _vm._v(" "), (
            item.status === 'Offen' ||
            item.status === 'Versendet' ||
            item.status === 'Überfällig' ||
            item.status === 'Gemahnt' ||
            item.status === 'Gemahnt überfällig'
          ) ? _c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.neuerStatus(item, 'Gezahlt')
              }
            }
          }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("check")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Rechnung als gezahlt markieren")])], 1) : _vm._e(), _vm._v(" "), (item.status === 'Entwurf SEPA') ? _c('v-list-item', {
            on: {
              "click": function($event) {
                _vm.showSendRechnungen = true
              }
            }
          }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("send")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Alle Rechnungen versenden und SEPA generieren")])], 1) : _vm._e(), _vm._v(" "), _c('buttonRechnungDownload', {
            attrs: {
              "type": "list",
              "icon": "download",
              "rechnung": item
            }
          }), _vm._v(" "), _c('v-list-item', {
            on: {
              "click": function($event) {
                (_vm.showDeleteRechnung = true) && (_vm.deleteRechnungID = item.id)
              }
            }
          }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Rechnung löschen")])], 1), _vm._v(" "), (item.status === 'Entwurf') ? _c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.alleEntwurfNeuerStatus()
              }
            }
          }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("send")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Alle Entwurf-Rechnungen versenden")])], 1) : _vm._e()], 1)], 1)], 1)])]
        }
      }, {
        key: "footer",
        fn: function() {
          return [_c('v-divider'), _vm._v(" "), _c('v-row', {
            attrs: {
              "no-gutters": ""
            }
          }, [(_vm.selected.length > 0) ? _c('v-btn', {
            attrs: {
              "text": ""
            },
            on: {
              "click": function($event) {
                _vm.showMehrereBearbeiten = true
              }
            }
          }, [_vm._v("bearbeiten")]) : _vm._e(), _vm._v(" "), (_vm.selected.length > 0) ? _c('v-btn', {
            attrs: {
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.sepaGenerieren(_vm.selected)
              }
            }
          }, [_vm._v("SEPA-Datei generieren")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
            staticClass: "subtitle-2 mt-2 mb-2 mr-6"
          }, [_vm._v("Summe: " + _vm._s(_vm.$filters.money(_vm.summe)))])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-pagination', {
            attrs: {
              "total-visible": 7,
              "length": _vm.pageCount
            },
            model: {
              value: (_vm.page),
              callback: function($$v) {
                _vm.page = $$v
              },
              expression: "page"
            }
          })]
        },
        proxy: true
      }], null, true)
    })], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('dialogRechnung', {
    attrs: {
      "visible": _vm.showRechnung,
      "rechnungid": _vm.selectRechnung.id
    },
    on: {
      "update:visible": function($event) {
        _vm.showRechnung = $event
      },
      "close": function($event) {
        _vm.showRechnung = false
      }
    }
  }), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showDeleteRechnung,
      "title": "Rechnung löschen",
      "message": "Willst du diese Rechnung wirklich löschen?",
      "abbrechen": "Abbrechen",
      "weiter": "Löschen"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteRechnung = $event
      },
      "closeTrue": function($event) {
        return _vm.deleteRechnung()
      },
      "closeFalse": function($event) {
        _vm.showDeleteRechnung = false
      }
    }
  }), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showDeleteMehrereRechnung,
      "title": _vm.selected.length + ' Rechnungen löschen',
      "message": 'Willst du wirklich ' + _vm.selected.length + ' Rechnung wirklich löschen?',
      "abbrechen": "Abbrechen",
      "weiter": "Löschen"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteMehrereRechnung = $event
      },
      "closeTrue": function($event) {
        return _vm.loescheMehrere()
      },
      "closeFalse": function($event) {
        _vm.showDeleteMehrereRechnung = false
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showSendRechnungen),
      callback: function($$v) {
        _vm.showSendRechnungen = $$v
      },
      expression: "showSendRechnungen"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Rechnungen mit SEPA versenden\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showSendRechnungen = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-stepper', {
    attrs: {
      "vertical": "",
      "flat": ""
    },
    model: {
      value: (_vm.stepperSendRechnungen),
      callback: function($$v) {
        _vm.stepperSendRechnungen = $$v
      },
      expression: "stepperSendRechnungen"
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.stepperSendRechnungen > 1,
      "step": "1"
    }
  }, [_vm._v(" SEPA-Datei generieren ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v("\n                Hier werden alle Rechnungen dieser Ansicht in einer SEPA-Datei zusammengefasst. Die Datei wird direkt\n                heruntergeladen und in der Datenbank für einen späteren Abruf gespeichert.\n                "), _c('br'), _c('br'), _vm._v("\n                Auch wenn das Datum in \"Zahlbar bis\" unterschiedlich ist, werden alle Rechnungen zum gleichen Datum\n                eingezogen. Das Datum kann dann auf der Seite der Bank angepasst werden.\n              ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showSendRechnungen = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.sepaGenerieren()
      }
    }
  }, [_vm._v("SEPA Generieren")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.stepperSendRechnungen > 2,
      "step": "2"
    }
  }, [_vm._v(" Rechnungen versenden ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v("\n                Hier können alle Rechnungen die gerade als SEPA-Datei zusammengefasst wurden zusammen versendet\n                werden. Der Versand kann längere Zeit dauern. (Dauer ca 30 Rechnungen/Minute)\n              ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.stepperSendRechnungen = 1
      }
    }
  }, [_vm._v("Zurück")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.loading) ? _c('v-progress-linear', {
    staticClass: "rounded ml-8 mr-2",
    attrs: {
      "value": _vm.progressSendSepa,
      "height": "30",
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.progressSendSepa) + "%")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.sepaRechnungenVersenden()
      }
    }
  }, [_vm._v("Versenden")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.stepperSendRechnungen > 3,
      "step": "3"
    }
  }, [_vm._v(" Abgeschlossen ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v(" Fertig. Du kannst das Fenster jetzt schließen. ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.stepperSendRechnungen = 2
      }
    }
  }, [_vm._v("Zurück")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showSendRechnungen = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showMehrereBearbeiten),
      callback: function($$v) {
        _vm.showMehrereBearbeiten = $$v
      },
      expression: "showMehrereBearbeiten"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.selected.length) + " Rechnungen bearbeiten\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showMehrereBearbeiten = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v(" Hier können für alle Rechnungen gleichzeitig bestimmte Felder angepasst werden. ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Titel"
    },
    model: {
      value: (_vm.bearbeiteteFelder.rechnung_titel),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "rechnung_titel", $$v)
      },
      expression: "bearbeiteteFelder.rechnung_titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Rechnungsdatum",
      "hint": "Format: 2022-03-17"
    },
    model: {
      value: (_vm.bearbeiteteFelder.rechnung_datum),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "rechnung_datum", $$v)
      },
      expression: "bearbeiteteFelder.rechnung_datum"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Rechnung Zahlbar bis",
      "hint": "Format: 2022-03-17"
    },
    model: {
      value: (_vm.bearbeiteteFelder.rechnung_zahlbar_bis),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "rechnung_zahlbar_bis", $$v)
      },
      expression: "bearbeiteteFelder.rechnung_zahlbar_bis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Status",
      "hint": "Möglich: Entwurf, Entwurf SEPA, Offen"
    },
    model: {
      value: (_vm.bearbeiteteFelder.status),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteteFelder, "status", $$v)
      },
      expression: "bearbeiteteFelder.status"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "red",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteMehrereRechnung = true
      }
    }
  }, [_vm._v("Löschen")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showMehrereBearbeiten = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.bearbeiteMehrere()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-105ab2d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/rechnungenListe.vue
// module id = 734
// module chunks = 15